import {
  makeLazyQueryHook,
  makeMutationHook,
  makeQueryHook,
} from "utils/apolloUtils";

import {
  GetVenues,
  GetVenuesVariables,
  GetVenue,
  GetVenueVariables,
} from "./__generated__/queries";
import { GET_VENUE, GET_VENUES } from "./queries";
import { CREATE_VENUE, DELETE_VENUE, UPDATE_VENUE } from "./mutations";
import {
  CreateVenue,
  CreateVenueVariables,
  DeleteVenue,
  DeleteVenueVariables,
  UpdateVenue,
  UpdateVenueVariables,
} from "./__generated__/mutations";

export const useVenueListQuery = makeQueryHook<GetVenues, GetVenuesVariables>(
  GET_VENUES
);

export const useVenueListLazyQuery = makeLazyQueryHook<
  GetVenues,
  GetVenuesVariables
>(GET_VENUES);

export const useVenueDetailsQuery = makeQueryHook<GetVenue, GetVenueVariables>(
  GET_VENUE
);

export const useVenueCreateMutation = makeMutationHook<
  CreateVenue,
  CreateVenueVariables
>(CREATE_VENUE);

export const useVenueUpdateMutation = makeMutationHook<
  UpdateVenue,
  UpdateVenueVariables
>(UPDATE_VENUE);

export const useVenueDeleteMutation = makeMutationHook<
  DeleteVenue,
  DeleteVenueVariables
>(DELETE_VENUE);
